module.exports = __webpack_public_path__ + "img/favicon-src.b04dca8819f51f13d9ad29d534690fcc.png";